import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';

import logo from '../../components/img/8bitpix_400.png';
import me from './me.png';

const Root = styled('div')(({ theme }) => ({
  maxWidth: 800,
  padding: '0 30px 30px',
  margin: 'auto',
  marginTop: -20,
  color: '#fff',
  '& a': {
    color: theme.palette.bitpix.main
  },
  '& img': {
    width: '100%'
  }
}));

const BitpixImage = styled('img')({
  width: '50%',
  maxWidth: 200
});

export default function About() {
  return (
    <Root>
      <img src={logo} alt="8bitpix" />
      <p>
        8bitpix is an online tool to configure, draw, save and publish pixel art avatars over social media.
        <br />Recreated from <a href="https://twitter.com/tuitpix">@tuitpix</a> by <a href="https://twitter.com/sergebruni">@sergebruni</a>.
        <br /><br />
        Advised by <a href="https://twitter.com/sadasant">@sadasant</a>
        <br /><br />
        Hosted in <a href="https://m.do.co/c/cf0ff9cae16a">DigitalOcean</a> by <a href="https://rogs.me/">@rogergonzalez21</a>.
        <br /><br /><br />
      </p>
      <Divider />
      <p>
        <BitpixImage src={me} alt="Sergio Bruni" /><br /><br />
        Hey yo!, Sergio Bruni here!. I'm a creative and dedicated designer developer open to new challenges and career opportunities.
        <br /><br />
        Full Stack developer with interest in Open Source Tools, strong orientation in Front-end Development.
        <br /><br /><br />
      </p>
      <Divider />
      <br /><br />
      <p>
        Licenses
        <br /><br />
        Every programming code in any form available here which does not explicitly says that belongs to another license is under the next copyright:
        <br /><br />
        Copyright © 2020 Sergio Bruni.
      </p>
    </Root>
  );
}
